.container {
  position: relative;
  width: 100%;
  border-radius: 0.8rem;
  padding: 0.4rem;
  min-width: 0;
  background: var(--color-grayscale-charleston);
  user-select: none;

  &[data-selected='true'] {
    box-shadow: inset 0 0 0 1.5px var(--color-secondary);
  }

  &:hover {
    cursor: pointer;
  }

  &[data-dragging='true'] {
    opacity: 0;
  }

  @media screen and (min-width: $bp-medium) {
    background: var(--color-grayscale-eerie-black);
  }
}

.file-header {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
}

.file-footer {
  padding: 0.8rem;

  @media screen and (min-width: $bp-medium) {
    padding: 0.8rem 0.8rem 0 0.8rem;
  }
}

.file-cover {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  border-radius: 0.6rem;
  background-color: #28292d;
  overflow: hidden;
}

.file-name {
  font-weight: 700;
  font-size: 1.3rem;
  line-height: 1.9rem;
  color: var(--color-grayscale-white);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: block;
  white-space: nowrap;
}

.modal-container {
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  cursor: pointer;
  z-index: 13;
}

.files-body-item-image {
  display: flex;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  height: 100%;
  border-radius: 0.6rem;
  margin-bottom: 1.2rem;
  background-color: black;

  &[data-hasLogo='true'] {
    background-color: #28292d;
  }

  svg {
    position: absolute;
    height: 6.4rem;
    width: 6.4rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.files-image-mp4 {
  position: absolute;
  height: 6.4rem;
  width: 6.4rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  svg {
    width: 100%;
    height: 100%;
  }
}

.image-cover {
  user-select: none;
  max-width: 100%;
  max-height: 100%;
}

.progress-loader {
  position: absolute;
  top: 0;
  left: 0;
  min-height: 10rem;
  height: 100%;
  width: 100%;
  display: flex;
  color: white;
  font-size: 40px;
  align-items: center;
  flex: 1;
  justify-content: center;
  z-index: 11;
}

.drag-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  border-radius: inherit;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.drag-overlay-text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #f7f8f8;
  margin-top: 1.6rem;
  text-align: center;
}

.drop-icon-wrapper {
  animation: bounce 1.5s ease-in-out infinite;

  @keyframes bounce {
    0% {
      transform: translateY(-0.2rem);
    }

    50% {
      transform: translateY(0.2rem);
    }

    100% {
      transform: translateY(-0.2rem);
    }
  }
}

.current-version-display {
  position: absolute;
  top: 1.6rem;
  left: 1.6rem;
  background-color: black;
  height: 2.8rem;
  width: 2.8rem;
  color: white;
  border-radius: 0.6rem;
  font-weight: 500;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  border: var(--color-grey-8) solid 1px;

  span {
    opacity: 0.7;
  }
}

.blocked-uploading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  z-index: 10;

  & span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 1.6rem;
    line-height: 1.9rem;
    font-weight: 700;
    z-index: 10;
    text-align: center;
    display: block;
  }
}

.video-duration {
  position: absolute;
  bottom: 0.8rem;
  right: 0.8rem;
  padding: 0.4rem;
  color: var(--color-grayscale-white);
  background: var(--color-grayscale-tuna);
  border-radius: 0.4rem;
}

.link-icon-wrapper {
  width: 100%;
  height: 100%;
  color: var(--color-grayscale-white);
  padding: 1.6rem;
  background-color: #1d1f24;
  border-radius: 0.6rem;
  opacity: 75%;

  &[data-onTopOfPreviewImage='true'] {
    width: 6.4rem;
    height: 6.4rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    svg {
      width: 3.2rem;
      height: 3.2rem;
    }
  }
}

.file-name-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
